import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import {
  IPaymentWalletTransactionHistoryResponse,
  IPaymentWalletTransactionHistoryResponseData,
} from "@/api_framework/api_modals/payment";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export interface IWalletHistoryProps {
  user_id: string;
  page_size: 10;
  page_number: 1;
}
export const usePaymentUserWalletHistoryAPI = () => {
  const configuration = useConfiguration();
  const [transaction, setTransaction] = useState<IPaymentWalletTransactionHistoryResponseData>(null);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  // isCustomerWalletDetailsInProgress
  const execute = useCallback(
    async (fromData: IWalletHistoryProps) => {
      try {
        dispatch(
          setLoading({
            key: "isCustomerTransactionTableInProgress",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(`${PAYMENT_MODULE?.TRANSACTION_HISTORY?.baseURL}`, {
            params: fromData,

            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IPaymentWalletTransactionHistoryResponse>) => {
            if (res.data.status === true) {
              setTransaction(res.data.data);
              dispatch(
                setLoading({
                  key: "isCustomerTransactionTableInProgress",
                  status: false,
                }),
              );
              return { status: true, message: "Cart Level Coupons Fetched" };
            } else {
              setTransaction(null);
              dispatch(
                setLoading({
                  key: "isCustomerTransactionTableInProgress",
                  status: false,
                }),
              );
              return { status: false, message: "No Cart Level Coupons" };
            }
          })
          .catch((e: AxiosError) => {
            setTransaction(null);
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: "isCustomerTransactionTableInProgress",
                status: false,
              }),
            );
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        setTransaction(null);
        dispatch(
          setLoading({
            key: "isCustomerTransactionTableInProgress",
            status: false,
          }),
        );
        captureError(e);
      }
    },
    [dispatch],
  );
  return { transaction, execute };
};
